module.exports = __webpack_public_path__ + "media/images/Plus-1-55cdb289be78da733e8cb463aa7a393e.svg";